import { FieldGuideStruct } from "../../structs/hospital-document/field-guide.struct";

export class CreateUpdateGuideGrievanceNotificationRequest {
    public idGuideGrievanceNotification: number;
    public idGrievanceNotification: number;
    public idEpisode: number;
    public idTriage: number;
    public idModule: number;
    public idGrievanceNotificationStatus: number;
    public numberOfGuide: string;
    public listFieldGuideStruct: FieldGuideStruct[] = [];
}